import { lazyComponentLoader } from 'src/utils/lazy-component-loader';

import { RouterBuilder } from './RouterBuilder';
import { ROUTES } from './constants';

const QuizPage = lazyComponentLoader(async () => import('../modules/quiz/quiz'));

const EmailPage = lazyComponentLoader(async () => import('../modules/email/email'));
const PaywallPage = lazyComponentLoader(async () => import('../modules/paywall/paywall'));
const SuccessPage = lazyComponentLoader(async () => import('../modules/success/success'));
const FailedPage = lazyComponentLoader(async () => import('../modules/failed/failed'));
const InstructionPage = lazyComponentLoader(async () => import('../modules/instruction/instruction'));
const DownloadAppPage = lazyComponentLoader(async () => import('../modules/download-app/download-app'));
const ShortPaymentPage = lazyComponentLoader(async () => import('../modules/short-payment/short-payment'));

const QuizRoute = {
  path: ROUTES.Index,
  Component: QuizPage,
};

const EmailRoute = {
  path: ROUTES.Email,
  Component: EmailPage,
};

const PaywallRoute = {
  path: ROUTES.Paywall,
  Component: PaywallPage,
};

const SuccessRoute = {
  path: ROUTES.Success,
  Component: SuccessPage,
};

const FailedRoute = {
  path: ROUTES.Failed,
  Component: FailedPage,
};

const InstructionRoute = {
  path: ROUTES.Instruction,
  Component: InstructionPage,
};

const DownloadAppRoute = {
  path: ROUTES.DownloadApp,
  Component: DownloadAppPage,
};

const ShortPaymentRoute = {
  path: ROUTES.ShortPayment,
  Component: ShortPaymentPage,
};

RouterBuilder.addPublicRoutes([QuizRoute, ShortPaymentRoute]);

RouterBuilder.addProtectedRoutes([
  EmailRoute,
  PaywallRoute,
  SuccessRoute,
  FailedRoute,
  InstructionRoute,
  DownloadAppRoute,
]);
